// extracted by mini-css-extract-plugin
export var apartments = "Dormitories-module--apartments--80708";
export var core = "Dormitories-module--core--18c1a";
export var dorms = "Dormitories-module--dorms--faade";
export var img1 = "Dormitories-module--img1--7ed36";
export var img2 = "Dormitories-module--img2--c79ec";
export var links = "Dormitories-module--links--924ac";
export var logo = "Dormitories-module--logo--d077c";
export var modalList = "Dormitories-module--modal-list--374b2";